import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { adminTheme } from "./theme/adminTheme";
import AdminLayout from "./layout/AdminLayout";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import OrganizerRequests from "./pages/OrganizerRequests";
import { useAuthContext } from "../contexts/AuthContext";

function AdminGuard({ children }) {
  const { isAdminAuthenticated } = useAuthContext();
  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

export default function AdminApp() {
  return (
    <ThemeProvider theme={adminTheme}>
      <CssBaseline />
      <Routes>
        {/* Login do admin — sem layout */}
        <Route path="login" element={<AdminLogin />} />

        {/* Rotas protegidas — com layout */}
        <Route
          path="*"
          element={
            <AdminGuard>
              <AdminLayout>
                <Routes>
                  <Route index element={<Dashboard />} />
                  <Route path="organizers/requests" element={<OrganizerRequests />} />
                  <Route path="*" element={<Navigate to="" replace />} />
                </Routes>
              </AdminLayout>
            </AdminGuard>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}
